import React, { FunctionComponent } from 'react';
import type { NavigationLink } from './types';

type Props = {
  navigationLinks: NavigationLink[];
  isFirst?: boolean
  isLast?: boolean;
  handleOpenMenu: (event: React.MouseEvent<HTMLHeadingElement>) => void;
};

export const Presentation: FunctionComponent<Props> = ({ navigationLinks, isFirst, isLast, handleOpenMenu }) => {
  return (
    <section className="search-form__bottom">
      {navigationLinks.length > 0 && (
        <nav className={`articles-container-bottom ${isLast ? 'last' : ''}`}>
          {navigationLinks.map((nv, index) => (
            <React.Fragment key={nv.title}>
              <h2 className={`articles-container-bottom-title ${isFirst && index === 0 ? 'active' : ''}`} onClick={handleOpenMenu}>
                {nv.title}
              </h2>
              <ul className="articles-container-bottom-menu gtm-bottom_toggle-view-count" style={{ display: isFirst && index === 0 ? 'block' : 'none' }} data-event-name='bottom_toggle on screen' data-category={nv.dataCategory || ''} data-value={nv.dataValue || ''}>
                {nv.links.map((link, index) => (
                  <li key={link[1]}>
                    {!nv.countZero[index] && <p className="articles-container-bottom-word is-link">{link[1]}</p>}
                    {nv.countZero[index] && (
                      <a
                        href={link[0]}
                        className="articles-container-bottom-word"
                        data-event="click"
                        data-category={nv.dataCategory || ''}
                        data-value={nv.dataValue || ''}
                      >
                        {link[1]}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </React.Fragment>
          ))}
        </nav>
      )}
    </section>
  );
};
